<template>
    <component
        :is="banner.url ? 'a' : 'div'"
        v-if="banner"
        :href="banner.url"
        target="_blank"
        :class="[$style.container, banner.narrowHidden ? $style.narrow_hidden : '']"
    >
        <img
            loading="lazy"
            :src="banner.src"
            :alt="banner.alt"
            :style="{ width: `${banner.width}px`, height: `${banner.height}px` }"
        />
    </component>
</template>
<script lang="ts" setup>
import { computed } from 'vue'

import { useTr } from '@/composables/use-tr'
import { YOUTUBE_URL } from '@/constants/general'
import type { PageAdType } from '@/modules/adv/types'

import noAdsBanner from './images/no_ads@2x.webp'
import youtubeBanner from './images/youtube@2x.webp'

const props = defineProps<{ placement: PageAdType }>()

const tr = useTr()

const banner = computed(() => {
    const BANNERS: Record<
        string,
        { width: number; height: number; src: string; url?: string; alt: string; narrowHidden?: boolean }
    > = {
        sidebar: { width: 300, height: 300, src: youtubeBanner, url: YOUTUBE_URL, alt: tr('adFreeBanners.youtube') },
        leaderboard: { width: 728, height: 90, src: noAdsBanner, alt: tr('adFreeBanners.noAds'), narrowHidden: true },
        leaderboard_rest: { width: 728, height: 90, src: noAdsBanner, alt: tr('adFreeBanners.noAds') },
    }
    return BANNERS[props.placement]
})
</script>
<style module>
.container {
    pointer-events: auto;
}

@media (min-width: 1024px) and (max-width: 1129px) {
    .narrow_hidden {
        display: none;
    }
}
</style>
